// extracted by mini-css-extract-plugin
export default {"page":"AllenamentiPage_page__zfU5Y","viewSwitch":"AllenamentiPage_viewSwitch__04SPx","viewRow":"AllenamentiPage_viewRow__zPDZZ"};